// extracted by mini-css-extract-plugin
export default {"container":"Ver_container__dT5pE","verRequisicion":"Ver_verRequisicion__5YRhc"};